module.exports = __webpack_public_path__ + "img/logo-kop.6997dc8b.png";